<template>
    <fragment>
        <li class="menu-section" :class="{ 'menu-item-open': hasActiveChildren }">
            <h4 class="menu-text">Quản lý tài chính</h4>
        </li>

        <!-- Menu Quản lý -->
        <MenuSubmenu
            v-if="hasPermission(permission.QUAN_LY_TAI_CHINH_2)"
            icon="fas fa-money-bill-wave"
            text="Quản lý"
            :items="managementMenuItems"
        />

        <!-- Menu Báo cáo -->
        <MenuSubmenu
            v-if="hasPermission(permission.BAO_CAO_TAI_CHINH)"
            icon="fas fa-tasks"
            text="Báo cáo"
            :items="reportMenuItems"
        />

        <!-- Menu kiểm toán -->
        <MenuSubmenu
            v-if="hasPermission(permission.KIEM_TOAN)"
            icon="fas fa-tasks"
            text="Kiểm toán"
            :items="auditMenuItems"
        />

      <!-- Menu Citime -->
      <MenuSubmenu
          v-if="hasPermission(permission.CITIME)"
          icon="fas fa-tasks"
          text="Citime"
          :items="citimeMenuItems"
      />
    </fragment>
</template>

<script>
import {mapGetters} from 'vuex'
import MenuSubmenu from './MenuSubmenu'

export default {
    name: 'QuanLyTaiChinh',

    components: {
        MenuSubmenu
    },

    computed: {
        ...mapGetters(['currentUser']),

        hasActiveChildren() {
            const activeRoutes = [
                '/customer-payments',
                '/edutalk-payment',
                '/move-amount',
                '/cost-price',
                '/idp-exam-register-list',
                '/phi-bo-tro-fee-list',
            ]
            return activeRoutes.some(route => this.$route.path.includes(route))
        },

        otherFeeMenuItems() {
            return [
                {
                    name: 'IdpExamRegisterList',
                    text: 'Phí IDP',
                    // permission: this.permission.DANG_KY_THI_IDP,
                },
                {
                    name: 'PhiBoTroFeeList',
                    text: 'Phí bổ trợ',
                    // permission: this.permission.QUAN_LY_PHI_BO_TRO,
                },
            ]
        },

        managementMenuItems() {
            return [
                {
                    name: 'customer-payments',
                    text: 'Nạp-Rút-Tặng quà',
                    permission: this.permission.NAP_RUT_TANG_QUA
                },
                {
                    name: 'edutalk-payment',
                    text: 'Edutalk thu tiền',
                    permission: this.permission.EDUTALK_THU_TIEN
                },
                {
                    name: 'move-amount',
                    text: 'Hợp đồng ứng',
                    permission: this.permission.HOP_DONG_UNG
                },
                {
                    name: 'cost-price',
                    text: 'Giá vốn',
                    permission: this.permission.GIA_VON
                },
                {
                    name: 'nap-rut-19-7',
                    text: 'Nạp, rút tiền trước 19-7',
                    permission: this.permission.NAP_RUT_197
                },
                {
                    name: 'tieu-so-du',
                    text: 'Xử lý số dư tài khoản',
                    permission: this.permission.XU_LY_SO_DU_TAI_KHOAN
                },
                {
                    name: 'tai-chinh-theo-khoa-hoc',
                    text: 'Khóa học đăng ký',
                    permission: this.permission.KHOA_HOC_DANG_KY
                },
                {
                    name: 'huy-tieu-khoa-hoc',
                    text: 'Hủy tiêu khóa học không có HĐ',
                    permission: this.permission.HUY_TIEU_KHOA_HOC
                },
                {
                    name: 'course-transfers-list',
                    text: 'Chuyển nhượng khóa học',
                    permission: this.permission.QUAN_LY_CHUYEN_NHUONG
                },
                {
                    name: 'refund-list',
                    text: 'Chương trình hoàn tiền',
                    permission: this.permission.CHUONG_TRINH_HOAN_TIEN
                },
                {
                    name: 'installment-information-list',
                    text: 'Duyệt trả góp',
                    permission: this.permission.DUYET_TRA_GOP
                },
                {
                    name: 'citime-index',
                    text: 'Thông tin Citime',
                    permission: this.permission.THONG_TIN_CITIME
                },
                {
                    name: 'book-costs-list',
                    text: 'Chi phí sách',
                    permission: this.permission.QUAN_LY_CHI_PHI_SACH
                },
                {
                    name: 'box-costs-list',
                    text: 'Chi phí box, admin',
                    permission: this.permission.QUAN_LY_CHI_PHI_BOX
                },
                {
                    text: 'Quản lý phí khác',
                    permission: this.permission.QUAN_LY_PHI_KHAC,
                    children: this.otherFeeMenuItems,
                },
                {
                    name: 'list-finance-transaction',
                    text: 'Quản lý vốn góp thực tế',
                    permission: this.permission.QUAN_LY_VON_GOP_THUC_TE
                },
                {
                    name: 'finance-actual-contributeds',
                    text: 'Chi văn phòng',
                    permission: this.permission.CHI_VAN_PHONG
                },
                {
                    name: 'list-course-gift',
                    text: 'Quản lý quà tặng',
                    permission: this.permission.QUAN_LY_QUA_TANG
                },
                {
                    name: 'export-course-gift',
                    text: 'Báo cáo xuất - nhập kho',
                    permission: this.permission.BAO_CAO_XUAT_NHAP_KHO
                },
            ]
        },

        reportMenuItems() {
            return [
                {
                    name: 'edutalk-center-payment',
                    text: 'Quyết toán trung tâm',
                    permission: this.permission.QUYET_TOAN_TRUNG_TAM
                },
                {
                    name: 'payment-log',
                    text: 'Khách hàng đóng tiền',
                    permission: this.permission.KHACH_HANG_DONG_TIEN
                },
                {
                    name: 'cong-no-khach-hang',
                    text: 'Công nợ khách hàng',
                    permission: this.permission.CONG_NO_KHACH_HANG
                },
                {
                    name: 'finance-branch-report-index',
                    text: 'Báo cáo tài chính văn phòng',
                    permission: this.permission.BAO_CAO_TAI_CHINH_VP
                },
                {
                    name: 'NetRevenueExport',
                    text: 'Doanh thu thuần',
                    permission: this.permission.QUAN_LY_DOANH_THU_THUAN
                },
                {
                    name: 'FinanceShareholderIndex',
                    text: 'Báo cáo cổ đông',
                    permission: this.permission.BAO_CAO_CO_DONG
                },
                {
                    name: 'TaxInvoiceList',
                    text: 'Hóa đơn thuế',
                    permission: this.permission.HOA_DON_THUE
                },
                {
                    name: 'StudentInvoice',
                    text: 'Học viên có hoá đơn',
                    permission: this.permission.HOA_DON_THUE
                },
                {
                    name: 'ClassInvoice',
                    text: 'Lớp học có hoá đơn',
                    permission: this.permission.HOA_DON_THUE
                }
            ]
        },

        auditMenuItems() {
            return [
                {
                    name: 'transaction-from-banks',
                    text: 'Danh sách nhận tiền từ ngân hàng',
                    permission: this.permission.NHAN_TIEN_TU_NGAN_HANG
                },
                {
                    name: 'audit-list',
                    text: 'Danh sách kiểm toán',
                    permission: this.permission.DANH_SACH_KIEM_TOAN
                },
                {
                  name: 'receipt-list',
                  text: 'Danh sách phiếu thu',
                  permission: this.permission.DANH_SACH_PHIEU_THU
                },
            ]
        },
        citimeMenuItems() {
            return [
                {
                    name: 'citime',
                    text: 'Danh sách trả góp Citime',
                    permission: this.permission.DANH_SACH_TRA_GOP,
                },

                {
                    name: 'citime-contract',
                    text: 'Quản lý hồ sơ Citime',
                    permission: this.permission.QUAN_LY_TRA_GOP
                }
            ]
        },
    },

    methods: {
        hasPermission(permission) {
            return this.currentUser?.user?.permission?.includes(permission)
        }
    }
}
</script>